import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectDocumentCategory = createSelector(
  [(store: RootState) => store.utils.category],
  (categoryList) => categoryList.filter(({ module }) => module === "document")
);
